export const PipelineReadinessStringMap = new Map<string, string>([
  ['Pending Tech Details', 'This data source needs connection information from its Tech owner.'],
  ['Data Source Pending Approval', 'This data source is pending review and approval by data owners.'],
  ['Pending Promote to Connector', 'This data source is pending its promotion to a connector.'],
  ['Connector Pending Approval', 'The connector for this data source needs further information and approval.'],
]);
